import { Model } from '../parents/model';

export class UserSessionModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_USER_ID = 'user_id';
  static ATTR_ACCESS_TOKEN = 'access_token';
  static ATTR_REFRESH_TOKEN = 'refresh_token';
  static ATTR_ACCESS_EXPIRATION_AT = 'access_expiration_at';
  static ATTR_SESSION_EXPIRATION_AT = 'session_expiration_at';

  /**
   * Cookie keys
   */
  static ACCESS_TOKEN_COOKIE_KEY = 'user_access_token';
  static REFRESH_TOKEN_COOKIE_KEY = 'user_refresh_token';

  get userId() {
    return this.attributes[UserSessionModel.ATTR_USER_ID];
  }

  get accessToken() {
    return this.attributes[UserSessionModel.ATTR_ACCESS_TOKEN];
  }

  get refreshToken() {
    return this.attributes[UserSessionModel.ATTR_REFRESH_TOKEN];
  }

  get accessExpirationAt() {
    return this.attributes[UserSessionModel.ATTR_ACCESS_EXPIRATION_AT];
  }

  get sessionExpirationAt() {
    return this.attributes[UserSessionModel.ATTR_SESSION_EXPIRATION_AT];
  }
}
